import { Error3ofk6owajcepa as Error_0 } from '../exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function throwIrLinkageError(message) {
  throw IrLinkageError().v(message);
}
var IrLinkageErrorClass;
function IrLinkageError() {
  if (IrLinkageErrorClass === VOID) {
    class $ extends Error_0() {
      static v(message) {
        var $this = this.x(message);
        captureStack($this, $this.u_1);
        return $this;
      }
    }
    initMetadataForClass($, 'IrLinkageError');
    IrLinkageErrorClass = $;
  }
  return IrLinkageErrorClass;
}
//region block: exports
export {
  throwIrLinkageError as throwIrLinkageError175icmue6aqas,
};
//endregion

//# sourceMappingURL=IrLinkageError.mjs.map
